import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Link, useLocation } from 'react-router-dom';

const SubscriptionBlockedModal = () => {
  const { subscriptionBlocked, subscriptionBlockReason, logout } = useAuth();
  const location = useLocation();

  // Never block the pages needed to actually resolve the issue
  const allowedPaths = ['/abbonamenti', '/contatti'];
  const onAllowedPath = allowedPaths.some((p) => location.pathname.startsWith(p));

  if (!subscriptionBlocked || onAllowedPath) return null;

  const isSuspendedByAdmin = subscriptionBlockReason?.reason === 'suspended_by_admin';

  return (
    <div className="fixed inset-0 z-[9999] bg-black/80 backdrop-blur-sm flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full overflow-hidden">
        {/* Header */}
        <div className={`p-6 ${isSuspendedByAdmin ? 'bg-red-600' : 'bg-amber-600'} text-white`}>
          <div className="flex items-center gap-3">
            <span className="material-symbols-outlined text-4xl">
              {isSuspendedByAdmin ? 'block' : 'warning'}
            </span>
            <div>
              <h2 className="text-xl font-bold">
                {isSuspendedByAdmin ? 'Account Sospeso' : 'Abbonamento Scaduto'}
              </h2>
              <p className="text-sm opacity-90">
                {isSuspendedByAdmin 
                  ? 'Il tuo account è stato sospeso'
                  : 'Il tuo abbonamento non è attivo'
                }
              </p>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="p-6">
          <p className="text-gray-700 mb-6">
            {subscriptionBlockReason?.message || 'Non puoi accedere al tuo account in questo momento.'}
          </p>

          {!isSuspendedByAdmin && (
            <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-6">
              <h3 className="font-bold text-amber-800 mb-2">Come risolvere:</h3>
              <ul className="text-sm text-amber-700 space-y-2">
                <li className="flex items-start gap-2">
                  <span className="material-symbols-outlined text-sm mt-0.5">check_circle</span>
                  Rinnova il tuo abbonamento per continuare ad usare tutti i servizi
                </li>
                <li className="flex items-start gap-2">
                  <span className="material-symbols-outlined text-sm mt-0.5">support_agent</span>
                  Contatta l'assistenza se pensi ci sia un errore
                </li>
              </ul>
            </div>
          )}

          {isSuspendedByAdmin && (
            <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
              <h3 className="font-bold text-red-800 mb-2">Cosa fare:</h3>
              <p className="text-sm text-red-700">
                Il tuo account è stato sospeso da un amministratore. 
                Contatta l'assistenza per maggiori informazioni.
              </p>
            </div>
          )}

          <div className="flex flex-col gap-3">
            {!isSuspendedByAdmin && (
              <Link
                to="/abbonamenti"
                className="w-full py-3 bg-amber-500 text-white rounded-lg font-bold text-center hover:bg-amber-600 transition-colors flex items-center justify-center gap-2"
              >
                <span className="material-symbols-outlined">credit_card</span>
                Rinnova Abbonamento
              </Link>
            )}
            
            <Link
              to="/contatti"
              className="w-full py-3 bg-gray-100 text-gray-700 rounded-lg font-bold text-center hover:bg-gray-200 transition-colors flex items-center justify-center gap-2"
            >
              <span className="material-symbols-outlined">mail</span>
              Contatta Assistenza
            </Link>

            <button
              onClick={logout}
              className="w-full py-3 text-gray-500 rounded-lg font-semibold text-center hover:text-gray-700 transition-colors"
            >
              Esci dall'account
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionBlockedModal;
